export * from "modules/TyreDiscountsDashboard/components/AddUpdateTyreBrandDiscountModal";
export * from "modules/TyreDiscountsDashboard/components/AddUpdateTyreDiscountModal";
export * from "modules/TyreDiscountsDashboard/components/DeleteTyreBrandDiscountModal";
export * from "modules/TyreDiscountsDashboard/components/DeleteTyreDiscountModal";
export * from "modules/TyreDiscountsDashboard/components/TyreBrandDiscountsTable";
export * from "modules/TyreDiscountsDashboard/components/TyreDiscountsTable";
